import { render, staticRenderFns } from "./Bind_WeChat.vue?vue&type=template&id=8128d33e&scoped=true"
import script from "./Bind_WeChat.vue?vue&type=script&lang=js"
export * from "./Bind_WeChat.vue?vue&type=script&lang=js"
import style0 from "./Bind_WeChat.vue?vue&type=style&index=0&id=8128d33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8128d33e",
  null
  
)

export default component.exports